<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    width="750px"
    :title="$t('SeaExport.CustomsReceiptRecord')"
    :close-on-click-modal="false"
    :append-to-body="true"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :style="{width:'100%',height:'450px'}"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { getCustomsInfoLog } from '@/api/seaExport/customsInfo'

export default {
  name: 'CustomsReceiptRecordDialog',
  props: {
    visible: { type: Boolean, required: true },
    selectedCustomsInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple'
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.CustomsTime'),
          field: 'noticeDate',
          width: 140
        },
        {
          headerName: this.$t('SeaExport.CustomsCode2'),
          field: 'entryId',
          width: 140
        },
        {
          headerName: this.$t('SeaExport.UnifiedCoding'),
          field: 'cusCiqNo',
          width: 140
        },
        {
          headerName: this.$t('SeaExport.CustomsDescription'),
          field: 'note',
          width: 140
        },
        {
          headerName: this.$t('SeaExport.CustomsStatus'),
          field: 'customsStatus',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.columnLabelFunc(SystemConstants.CUSTOMS_STATUS, params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      docType: [],
      user: {}
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    // 查询报关单对应日志
    async toQuery() {
      await getCustomsInfoLog({ customsInfoUuid: this.selectedCustomsInfo.uuid }).then(res => {
        if (res.data) {
          this.rowData = res.data
        }
      })
    }
  }
}
</script>

<style>
</style>
